import styled from "styled-components";

import { getDisabledStyle } from "../../../global.style";

export const StyledStepper = styled.div<{
    isDisabled: boolean;
}>`
    display: flex;
    flex-direction: column;
    ${props => getDisabledStyle(props.isDisabled)};
`;